import { render, staticRenderFns } from "./RussiaList.vue?vue&type=template&id=8eac4792&scoped=true&"
import script from "./RussiaList.vue?vue&type=script&lang=js&"
export * from "./RussiaList.vue?vue&type=script&lang=js&"
import style0 from "./RussiaList.vue?vue&type=style&index=0&id=8eac4792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eac4792",
  null
  
)

export default component.exports